import useOnClickOutside from 'common/hooks/useOnClickOutside';
import { Icon, Icons } from 'components/Icon';
import React, { useRef, useState } from 'react';
import AdminDropdown from './AdminDropdown';
import ImageAvatar from 'components/ImageAvatar';
import { selectAccountDetails } from 'selectors/account-selector';
import { useAppSelector } from 'store/hooks';
// import ImageAvatar from 'components/ImageAvatar';

type Props = {
  onClick: () => void;
  setShow: () => void;
};

export default function AdminNavBar({ onClick }: Props) {
  const [showDropdown, setShowDropdown] = useState<boolean>(false);
  const rootRef = useRef<HTMLInputElement>(null);

  const close = () => {
    setShowDropdown(false);
  };
  useOnClickOutside(rootRef, close);
  const { user } = useAppSelector(selectAccountDetails);

  return (
    <nav className="fixed left-0 top-0 z-10 flex  w-full justify-between bg-white px-2 pr-4 shadow">
      <div className="flex items-center justify-between p-3 lg:px-5 lg:pl-3">
        <div className="flex items-center justify-start">
          <button
            type="button"
            onClick={onClick}
            className="inline-flex items-center rounded-lg p-2 text-sm text-gray-500 hover:bg-gray-100 tablet:hidden sm:hidden"
          >
            <Icon name={Icons.DashboardHamburger} />
          </button>
        </div>
      </div>
      <div className="flex items-center gap-5">
        <div className="m-3 flex items-center gap-6">
          {/* <button type="button" className="">
            <Icon name={Icons.Notification} fill="#FF6600" />
          </button> */}
        </div>
        <div
          role="button"
          tabIndex={-1}
          ref={rootRef}
          className="xsm400:mx-3 xsm400:pr-40 md:m-3 md:pr-10"
          onClick={() => setShowDropdown(prevState => !prevState)}
        >
          <div className="flex items-center gap-3">
            <ImageAvatar imageUrl={''} className="h-12 w-12 rounded-full" />
            <span className="w-40 truncate text-sm font-bold text-[#353535]">{`${user?.surname} ${user?.othername}`}</span>
            <Icon name={Icons.ArrowDown} />
          </div>
          {showDropdown && (
            <div className="flex justify-end">
              <div className="absolute z-50 m-2 w-56 list-none divide-y divide-gray-100 rounded-lg bg-white text-base shadow">
                <AdminDropdown close={close} />
              </div>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
}
